var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconBlueprintLockSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconBlueprintLock",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1300.007 677c185.514 0 336.508 150.938 336.508 336.507V1247h142.5v514.632c0 87.354-71.03 158.383-158.383 158.383h-641.25c-87.353 0-158.382-71.03-158.382-158.383V1247h142.5v-233.493C963.5 827.937 1114.492 677 1300.007 677Zm281.17-338.177v225.882h-112.942v-112.94H451.765v1016.47h112.941v112.941H338.824V338.823h1242.353Zm-281.17 441.192c-128.713 0-233.492 104.779-233.492 233.492V1247H1533.5v-233.493c0-128.713-104.779-233.492-233.493-233.492ZM1242.353 0v225.882h-112.941V112.941H112.941v1016.471h112.941v112.94H0V0h1242.353Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconBlueprintLockSolid.glyphName = 'blueprint-lock';
IconBlueprintLockSolid.variant = 'Solid';
IconBlueprintLockSolid.displayName = 'IconBlueprintLockSolid';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconBlueprintLockSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconBlueprintLockSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconBlueprintLockSolid;
export { IconBlueprintLockSolid };